// extracted by mini-css-extract-plugin
module.exports = {"qp_table":"authHeader_qp_table__2vkgY","qp_table_small":"authHeader_qp_table_small__3lFQy authHeader_qp_table__2vkgY"};